import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import memoize from 'memoize-one'

import ConflictModal from '../../components/conflictModal/ConflictModal'
import Calendar from '../../components/calendar/Calendar'
import ShipVisitList from '../../components/shipVisitList/ShipVisitList'
import TerminalPlanner from '../../components/terminalPlanner/TerminalPlanner'
import { setSelectedVisit, onDateChange } from '../../components/app/actions'
import {
  getConflicts,
  getOverlappingTerminalVisits,
  getOverlappingExternalTerminalVisits
} from '../../utils/terminalVisitConflictsUtils'
import './TerminalViewer.scss'
import VisitsWebSocket from '../../components/visitsWebSocket/VisitsWebSocket'
import { reportPageView } from '../../utils/analyticsUtils'

const EMPTY_ARRAY = []
const VISIT_STATUSES = ['planned', 'assigned', 'nearby', 'moored', 'sailed']

/**
 * @class {TerminalViewer}
 * @property {Object} props
 */
class TerminalViewer extends PureComponent {
  static propTypes = {
    customFetch: PropTypes.func.isRequired
  }

  componentDidMount() {
    reportPageView('/home/planner')
  }

  // memoize the last returned result of conflicts to preventing re-render of ShipVisitList every time
  getConflictsMemoized = memoize(getConflicts)

  render() {
    const conflicts = this.getConflictsMemoized(
      this.props.app.present.terminalVisits,
      this.props.app.present.config.quays,
      this.props.app.present.config.etaTooLateThreshold,
      this.props.app.present.config.planningDelayTolerance
    )

    const terminalVisitsWithOverlap = getOverlappingTerminalVisits(
      this.props.app.present.terminalVisits,
      this.props.app.present.config.quays
    )

    const externalTerminalVisitsWithOverlap = getOverlappingExternalTerminalVisits(
      this.props.app.present.terminalVisits,
      this.props.app.present.config.quays
    )

    return (
      <div className="terminal-viewer main">
        <VisitsWebSocket customFetch={this.props.customFetch} currentTerminalId={this.props.login.auth.terminalId}>
          <ConflictModal
            conflictModalDimensions={this.props.app.present.conflictModalDimensions}
            conflictModalConflicts={this.props.app.present.conflictModalConflicts}
          />

          <div className="terminal-viewer-content">
            {!this.props.ui.terminalPlannerExpanded ? (
              <div className="sidebar-left">
                <Calendar
                  onDateRangeChange={this.onDateRangeChange}
                  selectedDateRange={this.props.app.present.dateRange}
                  berthsOccupation={this.props.app.present.berthsOccupation}
                  quays={this.props.app.present.config.quays}
                />

                <div className="ship-visit-list-container">
                  <ShipVisitList
                    selectedDateRange={this.props.app.present.dateRange}
                    terminalVisits={this.props.app.present.terminalVisits}
                    selectedVisit={this.props.app.present.selectedVisit}
                    selectedVisits={EMPTY_ARRAY}
                    onSelectVisit={this.handleSelectTerminalVisit}
                    statuses={VISIT_STATUSES}
                    getFilteredTerminalVisits={false}
                    scrollBarWidth={this.props.ui.scrollBarWidth}
                    conflicts={conflicts}
                    quays={this.props.app.present.config.quays}
                  />
                </div>
              </div>
            ) : null}

            <div className="main-container">
              <TerminalPlanner
                conflicts={conflicts}
                terminalVisitsWithOverlap={terminalVisitsWithOverlap}
                externalTerminalVisitsWithOverlap={externalTerminalVisitsWithOverlap}
                customFetch={this.props.customFetch}
                isAllowedToEdit
              />
            </div>
          </div>
        </VisitsWebSocket>
      </div>
    )
  }

  /**
   * When the user selects a visit -> set it in store
   * @param {TerminalVisit?} selectedVisit
   * @param {string?} selectedOrderId
   */
  handleSelectTerminalVisit = (selectedVisit, selectedOrderId) => {
    this.props.dispatch(setSelectedVisit(selectedVisit, selectedOrderId))
  }

  /**
   * Handle changing of date range
   * @param range
   */
  onDateRangeChange = range => {
    // Save date to redux
    this.props.dispatch(
      onDateChange(
        range,
        this.props.app.present.dataRange,
        this.props.login.auth.terminalId,
        this.props.app.present.config,
        this.props.login.auth.token,
        this.props.customFetch
      )
    )
  }
}

export default connect(state => state)(TerminalViewer)
